
import { Check, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface AccordionHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
  isValid: boolean;
  extraContent?: React.ReactNode;
}

export const AccordionHeader = ({ 
  icon: Icon, 
  title, 
  subtitle,
  isValid, 
  extraContent 
}: AccordionHeaderProps) => {
  return (
    <div className="flex items-center gap-4 w-full">
      <div className="relative">
        <Icon className="w-5 h-5" />
        {isValid && (
          <Check 
            className="w-3 h-3 text-white absolute -top-1 -right-1 rounded-full" 
            style={{ backgroundColor: '#16A34A' }} // Using green-600 equivalent for a darker green
          />
        )}
      </div>
      <div className="flex-1">
        <span>{title}</span>
        {subtitle && (
          <p className="text-sm font-normal text-muted-foreground">{subtitle}</p>
        )}
      </div>
      {extraContent}
    </div>
  );
};
